var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{attrs:{"shadow":"never"}},[_c('data-list',{attrs:{"table-style":{ name: 'mixture' },"data":_vm.data,"columns":_vm.column,"loading":_vm.loading,"page":_vm.page,"page-size":_vm.page.pageSize},on:{"page-size-changed":_vm.pageSizeChanged,"page-changed":_vm.pageChanged,"sort-change":_vm.sortChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }